import { ymapsTypes } from '@/entities';

export const setPlacemarkData = (placemarkRef: typeof ymapsTypes, iconCaption: string, balloonContent: string) => {
  if (!placemarkRef.current) return;

  placemarkRef.current.properties.set({ iconCaption: iconCaption, balloonContent: balloonContent });
};
